<template>
  <div style="margin:20px">
    <FiPageRail title="Data Sync — Drivers" nowrap-actions>
      <template slot="actions">
        <b-button size="sm" variant="outline-secondary" :disabled="loading" @click.prevent="load_data()"
                  aria-label="Refresh" title="Re-run the comparison">
          <i class="fa fa-refresh" aria-hidden="true"></i>
        </b-button>
      </template>
    </FiPageRail>

    <div v-if="loading" style="text-align:center">
      <br/><br/><b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <div v-else-if="!available" class="ds-panel"><div class="ds-empty">The driver comparison could not be run right now (telematics roster unavailable).</div></div>

    <div v-else>
      <div class="ds-summary">
        <span class="stat-chip"><b>{{ total_active }}</b> differences</span>
      </div>

      <ds-section title="In TBN, not in telematics"
                  :count="active_count('in_tbn_not_telematics', in_tbn_not_telematics, dkey)"
                  :excluded="excl_count('in_tbn_not_telematics', in_tbn_not_telematics, dkey)"
                  :open.sync="open.tbn" empty="Every TBN driver is in the telematics roster.">
        <table class="ds-table">
          <tr><th>Name</th><th>Phone</th><th width="70px"></th></tr>
          <tr v-for="(d, i) in in_tbn_not_telematics" :key="'t-' + i" :class="{'ds-row-excluded': is_excluded('in_tbn_not_telematics', dkey(d))}">
            <td>{{ d.name }}</td><td>{{ d.phone || '&mdash;' }}</td>
            <td align="center"><a class="ds-exclude-btn" :title="xtitle('in_tbn_not_telematics', dkey(d))"
                                  @click="toggle_item('in_tbn_not_telematics', dkey(d))">{{ xlabel('in_tbn_not_telematics', dkey(d)) }}</a></td>
          </tr>
        </table>
      </ds-section>

      <ds-section title="In telematics, not in TBN"
                  :count="active_count('in_telematics_not_tbn', in_telematics_not_tbn, dkey)"
                  :excluded="excl_count('in_telematics_not_tbn', in_telematics_not_tbn, dkey)"
                  :open.sync="open.tele" empty="Every telematics driver is in TBN.">
        <table class="ds-table">
          <tr><th>Name</th><th>Phone</th><th width="70px"></th></tr>
          <tr v-for="(d, i) in in_telematics_not_tbn" :key="'m-' + i" :class="{'ds-row-excluded': is_excluded('in_telematics_not_tbn', dkey(d))}">
            <td>{{ d.name }}</td><td>{{ d.phone || '&mdash;' }}</td>
            <td align="center"><a class="ds-exclude-btn" :title="xtitle('in_telematics_not_tbn', dkey(d))"
                                  @click="toggle_item('in_telematics_not_tbn', dkey(d))">{{ xlabel('in_telematics_not_tbn', dkey(d)) }}</a></td>
          </tr>
        </table>
      </ds-section>
    </div>
  </div>
</template>

<script>
import {get_data_sync_drivers} from '../networking/tbn_apis'
import {mapState} from 'vuex'
import DsSection from './data_sync_section'
import {dataSyncExclusions} from '../mixins/data_sync_exclusions'

export default {
  name: 'data_sync_drivers',
  components: {DsSection},
  mixins: [dataSyncExclusions('drivers')],
  data() {
    return {
      loading: false,
      available: true,
      in_tbn_not_telematics: null,
      in_telematics_not_tbn: null,
      exclusions: {},
      open: {tbn: false, tele: false},
    }
  },
  created() { this.load_data() },
  computed: {
    ...mapState({user: state => state.profile.user}),
    total_active() {
      return this.active_count('in_tbn_not_telematics', this.in_tbn_not_telematics, this.dkey)
           + this.active_count('in_telematics_not_tbn', this.in_telematics_not_tbn, this.dkey)
    },
  },
  watch: {
    'user.tenant'(n, o) { if (o && n !== o) this.load_data() },
  },
  methods: {
    dkey(d) { return d.phone || d.name },
    xtitle(cat, key) { return this.is_excluded(cat, key) ? 'Restore' : 'Exclude permanently' },
    xlabel(cat, key) { return this.is_excluded(cat, key) ? 'Restore' : 'Exclude' },
    async load_data(silent = false) {
      if (!silent) this.loading = true  // silent reload (exclude error resync) keeps the page in place
      try {
        const {value: {data = {}}} = await get_data_sync_drivers(this.user.tenant)
        this.available = data.available !== false
        this.in_tbn_not_telematics = data.in_tbn_not_telematics === undefined ? null : data.in_tbn_not_telematics
        this.in_telematics_not_tbn = data.in_telematics_not_tbn === undefined ? null : data.in_telematics_not_tbn
        this.exclusions = data.exclusions || {}
      } catch (e) {
        this.$emit('showAlert', 'error retrieving data, try again or contact support', 'danger', 5000)
      }
      if (!silent) this.loading = false
    },
  },
}
</script>

<style scoped>
@import './data_sync.css';
</style>
